import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
//import deburr from 'lodash/deburr';
import Autosuggest from 'react-autosuggest';
import match from 'autosuggest-highlight/match';
import parse from 'autosuggest-highlight/parse';
import AbEnvironment from '../auth/AbEnvironment';
import AppFetch from './AppFetch';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import { Button, Checkbox, FormControl, FormControlLabel, FormGroup, Grid,
         MenuItem, Paper, Select,
         Switch, TextField, Tooltip, Typography
} from '@mui/material';

//import Search from '@mui/icons-material/Search';
import HelpOutline from '@mui/icons-material/HelpOutline';

import AppCreateMutation from './AppCreateMutation';
import AccountFetch from '../account/AccountFetch';
import PageTitle from '../ui/PageTitle';
import SavingSpinner from '../ui/SavingSpinner'
import PercentageTextField from '../ui/PercentageTextField';
import AppBindStyles from '../../AppBindStyles';
import AppLogo from '../ui/AppLogo';
import { getValueForRender } from '../../utils/InputUtils';


const abEnvironment = new AbEnvironment();

function renderInputComponent(inputProps) {
  const { classes, inputRef = () => {}, ref, ...other } = inputProps;

  return (
    <TextField
      fullWidth
      InputProps={{
        inputRef: node => {
          ref(node);
          inputRef(node);
        },
        classes: {
          input: classes.input,
        },
      }}
      {...other}
    />
  );
}

function renderSuggestion(suggestion, { query, isHighlighted }) {
  const matches = match(suggestion.appName, query);
  const parts = parse(suggestion.appName, matches);

  // Is this template app or a vendor app?
  let accountId = abEnvironment.getUserAttribute('a_id');
  let isTemplate = false;
  let actionText = "Add app catalog entry";
  if (suggestion.accountId === accountId) {
    if (suggestion.appId == null) {
      actionText = "Add app catalog entry";
    } else {
      isTemplate = true;
      actionText = "Copy existing app catalog entry";
    }
  }

  // Setup the suggestion.  We now suggest all apps, so
  // each sku is shown as a distinct app.
  let skuPart = '';
  let modelPart = '';
  if (isTemplate) {
    if (suggestion.appSku != null && suggestion.appSku !== '' && suggestion.appSku !== suggestion.appName) {
      skuPart = ' ' + suggestion.appSku;
    }

    if (suggestion.paymentOrder === 1 && suggestion.appMarkupPercentage) {
      if (suggestion.appMarkupPercentage > 0) {
        modelPart = "Bill to customer (markup " + suggestion.appMarkupPercentage + "%)";
      } else if (suggestion.appMarkupPercentage === 0) {
        modelPart = "Bill to customer";
      } else  {
        modelPart = "Bill to customer (discount " + suggestion.appMarkupPercentage + "%)";
      }
    } else {
      modelPart = (abEnvironment.getUserAttribute('a_aType') === "1") ? "" : "Bill to me";
    }
  } else {
    if (suggestion.appSku != null && suggestion.appSku !== '' && suggestion.appSku !== suggestion.appName) {
      skuPart = ' ' + suggestion.appSku;
    }
  }

  return (
    <MenuItem selected={isHighlighted} component="div" className="suggestionContainer">
      <Grid container spacing={1} direction="row" justifyContent="flex-start">
        <Grid item xs={2} sm={1} md={1}>
          <AppLogo logoPath={suggestion.appLogo} appName={suggestion.appName} imageHeight='24px'/>
        </Grid>
        <Grid item xs={10} sm={11} md={3}>
          <Typography variant="subtitle1">
          {parts.map((part, index) => {
            if (part.highlight && suggestion.appLogo != null) {
              return (<strong key={index}>{part.text}</strong>);
            } else {
              return (part.text);
            }
          })}
          {skuPart}
          </Typography>
        </Grid>
        <Grid item xs={10} sm={11} md={5} className="asku">
          <Typography variant="subtitle1">
            {modelPart}
          </Typography>
        </Grid>
        <Grid item xs={10} sm={11} md={3} className="actionText">
          <Typography variant="subtitle1">
            {actionText}
          </Typography>
        </Grid>
      </Grid>
    </MenuItem>
  );
}

const getSuggestionValue = suggestion => suggestion.appName;

//these two needed to make warnings go away in autoselect.  Should not be the case according to doc.
function getSectionSuggestions(section) {
  return null;
}

function renderSectionTitle(section) {
  return null;
}

const styleSheet = theme => ({
    root: {
      flexGrow: 1,
    },
    flex: {
      flex: 1,
    },
    container: {
      position: 'relative',
    },
    '@global': {
      /* 960px or less */
      [theme.breakpoints.down( 'md' )]: {
        'div.suggestionContainer': {
          height: 24 * 4,
        },
        'div.asku': {
          marginLeft: '8.33%',
        },
        'div.actionText': {
          marginLeft: '8.33%',
        }
      },
      /* 600px or less */
      [theme.breakpoints.down( 'sm' )]: {
        'div.suggestionContainer': {
          height: 24 * 4,
        },
        'div.asku': {
          marginLeft: '16.66%',
        },
        'div.actionText': {
          marginLeft: '16.66%',
        }
      },
    },
    suggestionsContainerOpen: {
      position: 'absolute',
      zIndex: 1,
      marginTop: theme.spacing(1),
      left: 0,
      right: 0,
    },
    suggestion: {
      display: 'block',
    },
    suggestionsList: {
      margin: 0,
      padding: 0,
      listStyleType: 'none',
    },
    divider: {
      height: theme.spacing(2),
    },
    paper: {
      marginTop: 16,
      padding: theme.spacing(3),
      textAlign: 'left',
      color: theme.palette.text.secondary,
      maxWidth: 980
    },
    paperInner: {
      padding: theme.spacing(2)
    },
    percentageTextField: {
      margin: theme.spacing(1),
      marginLeft: 0,
      width: 110,
      minWidth: 110,
      textAlign: 'right',
      paddingLeft: 0
    },
    radioText: {
      marginTop: 14
    },
    customText: {
      margin: 8
    }
});

class AppCreate extends Component {

  constructor(props) {
    super(props);

    this.state = {
      suggestions: [],
      showSpinner: false,
      searchP: '',
      editDisabled: true,
      urlDisabled: true,
      value: 0,
      selectedApp: null,
      appId: null,
      accountId: abEnvironment.getUserAttribute('a_id'),
      appStatus: 0,
      appName: '',
      appSku: '',
      appUrl: '',
      signupUrl: '',
      appLogo: null,
      description: '',
      appType: 0,
      parentAppId: null,
      oemAppId: null,
      atId: 'f5c70f86-135a-11e8-bb45-97ef56920c02',
      appSkuPrice: 0.00,
      appMarkupAbsolute: 0.00,
      appMarkupPercentage: (abEnvironment.getUserAttribute('a_aType') === "1")  ? 10.0 : 0,  //vendor default markup to 10%,
      jitFloatDefault: 0,
      marqetaMid: null,
      marqetaMname: null,
      maxCharge: 1000.00,
      paymentOrder: 4, 
      passThroughFees: 1,
      wholesaleDiscountPercentage: 0,
      showDomain: 0,
      showUserName: 0,
      file: null,
      accountLogo: null
    }
  }

  componentDidMount() {
    //if user is a vendor, fetch account and see if there is a logo on it to use as default.
    if (this.props.auth.isAuthenticatedVendor()) {
      this.fetchAccount();
    }
  }

  /* See if there is an account logo */
  fetchAccount = () => {
    let accountId = abEnvironment.getUserAttribute('a_id');
    AccountFetch.fetch(accountId).toPromise()
    .then(af => {
       if (af.accountTByAccountId) {
         this.setState({accountLogo: af.accountTByAccountId.logo});
       }
    })
    .catch(err => {
      //nothing to do....
    })
  }


  getValueForRender(state_member, prop_member, theDefault)
  {
    if (state_member != null)
      return state_member;

    if (prop_member != null)
    {
      state_member = prop_member;
      return prop_member;
    }

    return theDefault;
  }

  getValueForWhoPaysRender() {
      
    if (this.state.paymentOrder != null) {
      if (this.state.paymentOrder <= 1) {
        return 1;
      }
      else {
        return 2;
      }
    }

    return 1;
  }


  setStateFromSelection(anode)
  {
    let appName = anode.appName;
    if (appName.length > 64) {
      appName = appName.substring(0, 64)
    }

    let disableUrl = true;
    if (anode.appUrl.length === 0)
      disableUrl = false;

    let amPerc = 0.00;
    if (anode.appMarkupPercentage) {
      amPerc = anode.appMarkupPercentage;
    }

    let wdPerc = 0.00;
    if (anode.wholesaleDiscountPercentage) {
      wdPerc = anode.wholesaleDiscountPercentage;
    }

    let oemAppId = null;
    if (this.props.auth.isAuthenticatedReseller()) {
      let accountId = abEnvironment.getUserAttribute('a_id');
      if (anode.accountId === accountId) {
        //I am a reseller and I am making a copy of an app I "own"
        if (anode.oemAppId) {
          //if the app has an oem app id, it means this app was copied from a vendor app, keep it.
          oemAppId = anode.oemAppId;
        }
      } else {
        //I am a reseller and I am making a copy of app that is not my account, set oem app id to vendor
        oemAppId = anode.appId;
      }
    }

    let expensingActive = false;
    let expensing = abEnvironment.getFlagValue("expensing");
    if (expensing != null && expensing.flagValue === 1) {
      expensingActive = true;
    }

    let thePaymentOrder = anode.paymentOrder;
    if (thePaymentOrder === 1) {
      thePaymentOrder = 0;
    }
    if (expensingActive === false) {
      if (thePaymentOrder === 0 || thePaymentOrder === 1 || thePaymentOrder === 2) {
        thePaymentOrder = 4;
      }
    }

    var newStateVals = {
        // selectedSku: skuidx,
        searchP: appName,
        urlDisabled: disableUrl,
        editDisabled: false,
        selectedApp: anode,
        appName: appName,
        appUrl: anode.appUrl,
        signupUrl: (anode.signupUrl ? anode.signupUrl : ''),
        appLogo: anode.appLogo,
        appSku: anode.appSku,
        oemAppId: oemAppId,
        description: anode.description,
        marqetaMid: anode.marqetaMid,
        marqetaMname: anode.marqetaMname,
        maxCharge: anode.maxCharge,
        paymentOrder: thePaymentOrder,
        appMarkupPercentage: amPerc,
        passThroughFees: 1,
        wholesaleDiscountPercentage: wdPerc
    }

    this.setState(newStateVals);
  }

  goBack() {
    this.props.history.goBack();
  }

  handleChange = name => event => {
    if (name === 'searchP')
    {
      let newStateVals = {
        searchP: event.target.value
      };
      this.setState(newStateVals);
    }
    else
    {
      this.setState({
        [name]: event.target.value,
      });
    }
  };

  showSpinner() {
    return this.state.showSpinner;
  }

  _createApp = () => {
    this.setState({ showSpinner: true });
    const { accountId, appStatus, appName, appSku, appUrl, signupUrl, appLogo,
            description, appType, parentAppId, oemAppId, atId,
            appSkuPrice, appMarkupAbsolute, appMarkupPercentage, jitFloatDefault,
            marqetaMid, marqetaMname, maxCharge, paymentOrder, passThroughFees, wholesaleDiscountPercentage, showDomain, showUsername } = this.state;

    let logo = appLogo;
    if (!logo && this.props.auth.isAuthenticatedVendor()) {
      logo = this.state.accountLogo;
    }
    AppCreateMutation.commit(accountId, appStatus, appName,
                             appSku, appUrl, signupUrl, logo, description, appType,
                             parentAppId, oemAppId, atId,
                             appSkuPrice, appMarkupAbsolute, appMarkupPercentage, jitFloatDefault,
                             marqetaMid, marqetaMname, maxCharge, paymentOrder, passThroughFees, wholesaleDiscountPercentage, null, showDomain, showUsername)
    .then(response => {
      this.setState({ showSpinner: false });
      this.goBack();
    })
    .catch(error => {
      this.setState({ showSpinner: false });
      this.goBack();
    });
  }

  handleRadioChange = event => {
    let theNum = parseInt(event.target.value, 10);
    this.setState({paymentOrder: theNum});
  }

  disableAppSave() {
    //check for valid domains in the Url fields
    if (this.disableForInvalidDomainName(this.state.appUrl) || 
        this.disableForInvalidDomainName(this.state.signupUrl))  {
      return true;
    }  

    if (this.areFieldsInError()) {
      return true;
    }

    return false;
  }
  
  disableForInvalidDomainName(stateVar) {

    if (stateVar !== null && stateVar !== '') {
         //Validate against reg ex domain check  (used this pattern: https://regexr.com/3au3g)
        var re = new RegExp(/(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9]/); 
        return !re.test(stateVar);
    } else {
      return false;
    }

  }

  submitFile = event => {
    event.preventDefault();

    const { callPartnerApi, logError } = this.props.auth;
    let theFile = this.state.file[0];
    let theFilename = theFile.name;
    let theFiletype = theFile.type;
    const formData = new FormData();
    formData.append('fname', theFilename);
    formData.append('ftype', theFiletype);
    formData.append('file', theFile);
    callPartnerApi('appbind/logo',
                   'POST',
                   formData,
                   false,
                   'multipart/form-data')
    .then(response => {
      // TODO
/*
      return response.text();
    })
    .then(theText => {
*/
    })
    .catch(error => {
      logError('Exception in AppCreate.js: ' + error);
    });
  }

  handleFileUpload = event => {
    this.setState({file: event.target.files});
  }

  onSuggestionsFetchRequested = ({ value }) => {
    this.fetchApps(value);
  }

  onSuggestionsClearRequested = () => {
    this.setState({suggestions: []});
  }

  onSuggestionSelected = (event, { suggestion, suggestionValue, suggestionIndex, sectionIndex, method }) =>{
    // alert(suggestionValue);
    this.setStateFromSelection(suggestion);
  }

  /*
   * Lookup available apps by app name
   */
  fetchApps = (searchParm) => {
    //let parentId = abEnvironment.getUserAttribute('a_parentId');
    let accountId = abEnvironment.getUserAttribute('a_id');

    AppFetch.fetch(accountId, searchParm, 0, 50).toPromise()
    .then(af => {
      const thenodes = af.appsearchallavailablebyappname2.nodes;

      //
      // Show each individual template app and vendor app
      //
      // Previously, vendor apps were consolidated (if there were
      // multiple skus of the same app, they were shown as one
      // entry).  Now we're showing each distinct entry, so there
      // is no difference in behavior between vendor apps and template
      // apps.
      //
      let theApps = [];
      let adx = 0;
      for (let i=0; i<thenodes.length; i++)
      {
        let n = thenodes[i];

        var anApp = {
          appIdx: adx,
          accountId: n.accountId,
          appName: n.appName,
          appUrl: n.appUrl,
          signupUrl: n.signupUrl,
          appLogo: n.appLogo,
          appMarkupPercentage: n.appMarkupPercentage,
          appId: n.appId,
          appSku: n.appSku,
          oemAppId: n.oemAppId,
          description: n.description,
          marqetaMid: n.marqetaMid,
          paymentOrder: n.paymentOrder,
          passThroughFees: n.passThroughFees,
          wholesaleDiscountPercentage: n.wholesaleDiscountPercentage,
          showDomain: n.showDomain,
          showUsername: n.showUsername
        };
        theApps.push(anApp);
        adx++;

        if (adx >= 10)
          break;
      };

      if (adx === 0)
      {
        // Custom App Entry
        var custApp = {
          appIdx: adx,
          accountId: abEnvironment.getUserAttribute('a_id'),
          appName: searchParm,
          appUrl: '',
          signupUrl: '',
          appLogo: this.getCustomAppLogo(),
          appMarkupPercentage: 0.00,
          appId: null,
          appSku: '',
          description: searchParm,
          marqetaMid: null,
          paymentOrder: 1,
          passThroughFees: 1,
          wholesaleDiscountPercentage: 0.00,
          showDomain: 0,
          showUsername: 0
        };
        theApps.push(custApp);
      }
      this.setState({suggestions: theApps});
    })
    .catch(err => {
      this.setState({suggestions: []});
    })
  }

  getCustomAppLogo() {
    if (this.props.auth.isAuthenticatedVendor()) {
      //if a vendor and they have a logo set, use it to default drop down
      if (this.state.accountLogo !== null) {
        return this.state.accountLogo;
      } else {
        return null;
      }
    } else {
      return null;
    }  
  }

  
  getErrorMessage(field, minValue, maxValue) {
    let errMesg = null;

    let value = Number(field); 
    if (value < minValue) {
      return 'Cannot be less than ' + minValue;
    }
    if (value > maxValue) {
      return 'Cannot be greater than ' + maxValue;
    }

    return errMesg;
  }

  areFieldsInError() {
    if (this.getErrorMessage(this.state.appMarkupPercentage, -100, 900) !== null) {
      return true;
    }
    if (this.getErrorMessage(this.state.wholesaleDiscountPercentage, 0, 100) !== null) {
      return true;
    }
    return false;
  }

  render() {
    const { isAuthenticated, isAuthenticatedReseller, isAuthenticatedVendor, needAssent } = this.props.auth;
    const classes = this.props.classes;
    // const { anchorEl } = this.state;

    // For now, showing wholesale discount for all apps.  We anticipate
    // overriding this on an app by app basis in the future.
    let showWholesaleDiscount = true;

    let wholesaleTooltip = `Some software vendors sell partners discounted subscriptions. You in turn then mark the subscription up and sell it to your customers.
    \n\r
    It’s important to show only the retail price for the subscription to your customer. Any discounts should come from you, which you can add on the next line below.`

    if (!isAuthenticated() || needAssent()) {
      return (
        <Redirect to='/home' />
      );
    } else if (isAuthenticatedReseller() || isAuthenticatedVendor()) {

      let additionalFieldsToolip = 'All apps have email and password fields. Some have additional fields (e.g. username); if needed, you can select these here';

      // Only show expensing optiona if expensing is enabled
      let expensingActive = false;
      let expensing = abEnvironment.getFlagValue("expensing");
      if (expensing != null && expensing.flagValue === 1) {
        expensingActive = true;
      }

      let thePaymentOrder = getValueForRender(this.state.paymentOrder, 4);
      if (thePaymentOrder === 1) {
        thePaymentOrder = 0;
      }
      if (expensingActive === false && (thePaymentOrder === 0 || thePaymentOrder === 2)) {
        thePaymentOrder = 4;
      }

      let expenseToCustomerTitle = 'Expense to customer';
      let expenseToCustomerDescription = 'Automatically expense this subscription to my customer after I sign up on their behalf.';
      let expenseToMeTitle = 'I will pay';
      let expenseToMeDescription = 'I will cover the cost of the subscription as part of the project.';
      let requestAccessTitle = 'Request access';
      let requestAccessDescription = 'Ask my customer to share their password or invite me into their subscription.';
      let signUpTitle = "I will sign up";
      let signUpDescription = "I will sign up for this subscription on behalf of my customer.";

      return (
        <Grid container spacing={3} direction="row" justifyContent="flex-start">
          <Grid item xs={12}>
            <PageTitle title="Add app" showBackButton={true} name="app catalog" noMargin={true} history={this.props.history}/>
          </Grid>
          <Grid item xs={12}>
            <Paper className={classes.paper}>
              <Autosuggest
                renderInputComponent={renderInputComponent}
                suggestions={this.state.suggestions}
                onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                onSuggestionSelected={this.onSuggestionSelected}
                getSuggestionValue={getSuggestionValue}
                renderSuggestion={renderSuggestion}
                multiSection={false}
                renderSectionTitle={renderSectionTitle}
                getSectionSuggestions={getSectionSuggestions}
                inputProps={{
                  classes,
                  placeholder: "Type an app name here",
                  value: this.state.searchP,
                  onChange: this.handleChange('searchP')
                }}
                theme={{
                  container: classes.container,
                  suggestionsContainerOpen: classes.suggestionsContainerOpen,
                  suggestionsList: classes.suggestionsList,
                  suggestion: classes.suggestion,
                }}
                renderSuggestionsContainer={options => (
                  <Paper {...options.containerProps} square>
                    {options.children}
                  </Paper>
                )}
              />
              <Grid container spacing={2} direction="row" justifyContent="space-between" style={{marginTop: 16}} >    
                <Grid item xs={12} >
                  <Paper className={classes.paperInner}>
                    <Grid container spacing={2} direction="row" justifyContent="space-between" >
          
                        
                      {!this.state.editDisabled &&
                        <Grid item xs={12}>
                          <Typography variant="h6">App description</Typography>
                        </Grid>                    
                      }      
                      <Grid item xs={12} md={6} >
                        <TextField
                          id="app-name" label="App name" 
                          value={this.state.appName}
                          disabled={this.state.editDisabled}
                          onChange={(e) => this.setState({ appName: e.target.value })}
                          inputProps={{ maxLength: 64 }}
                        />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <TextField
                          id="app-sku" label="Subscription plan"
                          value={this.state.appSku}
                          disabled={this.state.editDisabled}
                          onChange={(e) => this.setState({ appSku: e.target.value })} 
                          inputProps={{ maxLength: 32 }}/>
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          id="description" label="Description"
                          value={this.state.description}
                          fullWidth
                          multiline
                          disabled={this.state.editDisabled}
                          onChange={(e) => this.setState({ description: e.target.value })}
                          inputProps={{ maxLength: 2048 }} />
                      </Grid>
                    </Grid>
                  </Paper>
                </Grid>

                { /*(false && ! this.state.urlDisabled) &&
                  <Grid item xs={12}>
                    <form onSubmit={this.submitFile}>
                      <input label='upload file' type='file' onChange={this.handleFileUpload}/>
                      <button type='submit'>Upload</button>
                    </form>
                  </Grid>*/
                }

                {(!this.state.editDisabled ) &&
                <Grid item xs={12}>
                  <Paper className={classes.paperInner}>
                    <Grid container spacing={2} direction="row" justifyContent="space-between">
                      <Grid item xs={12}>
                        <Typography variant="h6">Login and signup</Typography>
                      </Grid>                          
                      <Grid item xs md={6}>
                        <TextField
                          id="login-url" label="Login link" 
                          value={this.state.appUrl}
                          disabled={this.state.editDisabled}
                          onChange={(e) => this.setState({ appUrl: e.target.value })} 
                          inputProps={{ maxLength: 256 }}/>
                      </Grid>
                      <Grid item xs md={6}>
                        <TextField
                          id="referral-url" label="Signup/referral link" 
                          value={this.state.signupUrl}
                          disabled={this.state.editDisabled}
                          onChange={(e) => this.setState({ signupUrl: e.target.value })} 
                          inputProps={{ maxLength: 256 }}/>
                      </Grid>
                      { (!this.state.editDisabled && this.state.oemAppId == null) &&
                      <React.Fragment>
                        <Grid item xs={12}/>
                        <Grid item xs={12}>
                          <Grid container direction="column" spacing={0}>
                            <Grid item style={AppBindStyles.markupDescription}> 
                              <Typography variant="h6" display="inline">Configure additional fields</Typography>
                              <Tooltip placement='bottom' title={additionalFieldsToolip}>
                                <HelpOutline fontSize="small" style={{verticalAlign: "-16%", marginLeft: '4px'}}/>
                              </Tooltip>
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <FormControlLabel
                            control={
                            <Checkbox checked={this.state.showDomain === 1} 
                              onChange={() => this.setState({showDomain: (this.state.showDomain === 1) ? 0 : 1})}
                              />
                            }
                            label="Show domain"
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <FormControlLabel
                            control={
                            <Checkbox checked={this.state.showUsername === 1} 
                              onChange={() => this.setState({showUsername: (this.state.showUsername === 1) ? 0 : 1})}
                              />
                            }
                            label="Show user name"
                            />
                        </Grid>
                      </React.Fragment>}
                    </Grid>
                  </Paper>
                </Grid>}
                
                {isAuthenticatedReseller() && !this.state.editDisabled &&
                <Grid item xs={12}>
                  <Paper className={classes.paperInner}>
                    <Grid container spacing={1} direction="row" justifyContent="space-between" >
                      <Grid item xs={12}>
                        <Grid container spacing={0} direction="row" justifyContent="flex-start">
                          <Grid item xs={12}>
                            <Typography variant="h6" >Sharing model default</Typography>
                          </Grid>                          
                          <Grid item xs={12}>
                            <Typography variant="body2">Set the default sharing model for subscriptions to {this.state.appName}</Typography>
                          </Grid>
                        </Grid>
                      </Grid>

                      <Grid item xs={12}>
                        <TextField
                          value={thePaymentOrder}
                          onChange={(e) => {
                            if (e.target.value === 2) {
                              this.setState({ paymentOrder: e.target.value, appMarkupPercentage: 0, wholesaleDiscountPercentage: 0 });
                            } else {
                              this.setState({ paymentOrder: e.target.value });
                            }
                          }}
                          label="Sharing model"
                          select
                          fullWidth
                          autoFocus
                          variant="standard"
                        >
                          <MenuItem value="NA" disabled>
                              <Typography align="left" variant="body1">Select a sharing model</Typography>
                          </MenuItem>
                          <MenuItem value={4}>
                              <Grid container spacing={0}>
                                  <Grid item xs={12}>
                                      <Typography align="left" variant="body1" style={AppBindStyles.boldLabel}>{requestAccessTitle}</Typography>
                                  </Grid>                  
                                  <Grid item xs={12}>
                                      <Typography align="left" variant="body2">{requestAccessDescription}</Typography>
                                  </Grid>
                              </Grid>
                          </MenuItem>
                          <MenuItem value={5}>
                              <Grid container spacing={0}>
                                  <Grid item xs={12}>
                                      <Typography align="left" variant="body1" style={AppBindStyles.boldLabel}>{signUpTitle}</Typography>
                                  </Grid>                  
                                  <Grid item xs={12}>
                                      <Typography align="left" variant="body2">{signUpDescription}</Typography>
                                  </Grid>
                              </Grid>
                          </MenuItem>
                          {expensingActive === true &&
                          <MenuItem value={0}>
                              <Grid container spacing={0}>
                                  <Grid item xs={12}>
                                      <Typography align="left" variant="body1" style={AppBindStyles.boldLabel}>{expenseToCustomerTitle}</Typography>
                                  </Grid>                  
                                  <Grid item xs={12}>
                                      <Typography align="left" variant="body2">{expenseToCustomerDescription}</Typography>
                                  </Grid>
                              </Grid>
                          </MenuItem>}
                          {expensingActive === true &&
                          <MenuItem value={2}>
                              <Grid container spacing={0}>
                                  <Grid item xs={12}>
                                      <Typography align="left" variant="body1" style={AppBindStyles.boldLabel}>{expenseToMeTitle}</Typography>
                                  </Grid>                  
                                  <Grid item xs={12}>
                                      <Typography align="left" variant="body2">{expenseToMeDescription}</Typography>
                                  </Grid>
                              </Grid>
                          </MenuItem>}
                        </TextField>
                      </Grid>                      

                      {thePaymentOrder === 0 &&
                      <React.Fragment>
                        {showWholesaleDiscount &&
                        <React.Fragment>
                          <Grid item xs={12}/>
                          <Grid item>
                            <Grid container direction="column" spacing={0}>
                              <Grid item>
                                <Typography variant="body1"  style={AppBindStyles.boldLabel}>If you are buying {this.state.appName} with a partner discount, enter it here</Typography>
                              </Grid>
                              <Grid item style={AppBindStyles.markupDescription}> 
                                <Typography variant="caption" >(e.g. if you’re charged $80 at a 20% discount, we’ll show the customer a retail price of $100)</Typography>
                                <Tooltip placement='bottom' title={wholesaleTooltip}>
                                  <HelpOutline fontSize="small" style={{verticalAlign: "-16%", marginLeft: '4px'}}/>
                                </Tooltip>
                              </Grid>
                            </Grid>
                          </Grid>
                          <Grid item>
                            <PercentageTextField 
                              id="wholesale-disc-percentage" className={classes.percentageTextField}
                              value={this.state.wholesaleDiscountPercentage}
                              disabled={this.state.editDisabled}
                              showErrMsg={true}
                              allowNegative={false}
                              minValue={0}
                              maxValue={100}
                              minEnterValue={0}
                              maxEnterValue={9999}
                              onChange={(e) => this.setState({ wholesaleDiscountPercentage: e.target.value })} 
                              textAlign="right"/>
                          </Grid>
                        </React.Fragment>
                        }
                        <Grid item xs={12}/>
                        <Grid item>
                          <Grid container direction="column" spacing={0}>
                            <Grid item>
                              <Typography variant="body1"  style={AppBindStyles.boldLabel}>{"Add your management fee or discount"}</Typography>
                            </Grid>
                            <Grid item style={AppBindStyles.markupDescription}> 
                              <Typography variant="caption">Add a management fee (e.g. 20%) or a discount (e.g. -10%)</Typography>
                              <Tooltip placement='bottom' title={'On top of the retail price, you can add your own management fee or discount.'}>
                                <HelpOutline fontSize="small" style={{verticalAlign: "-16%", marginLeft: '4px'}}/>
                              </Tooltip>
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid item>
                          <PercentageTextField 
                            id="app-markup-percentage" className={classes.percentageTextField}
                            value={this.state.appMarkupPercentage}
                            disabled={this.state.editDisabled}
                            onChange={(e) => this.setState({ appMarkupPercentage: e.target.value })} 
                            allowNegative={true}
                            showErrMsg={true}
                            minValue={-100}
                            maxValue={900}
                            minEnterValue={-9999}
                            maxEnterValue={9999}
                            textAlign="right"
                          />
                        </Grid>
                        <Grid item xs={12}/>
                        <Grid item>
                          <Grid container direction="column" spacing={0}>
                            <Grid item>
                              <Typography variant="body1" style={AppBindStyles.boldLabel}>Pass payment fees to my customer</Typography>
                            </Grid>
                            <Grid item style={AppBindStyles.markupDescription}> 
                              <Typography variant="caption">AppBind charges 1% plus any credit card fees</Typography>
                              <Tooltip placement='bottom' title='If funding by credit card, fees are 2.9% US and 3.9% international + $0.30'>
                                <HelpOutline fontSize="small" style={{verticalAlign: "-16%", marginLeft: '4px'}}/>
                              </Tooltip>
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid item>
                          <Switch
                            checked={this.state.passThroughFees === 1}
                            onChange={(e, checked) => {
                              if (checked) {
                                this.setState({ passThroughFees: 1});
                              } else {
                                this.setState({ passThroughFees: 0});
                              }
                            }}
                          />
                        </Grid>
                      </React.Fragment>}
                    </Grid>
                  </Paper>
                </Grid>}
                <Grid item xs={12}>
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={this.getValueForRender(this.state.appStatus === 0)}
                          disabled={this.state.editDisabled}
                          onChange={(e, checked) => {
                            if (checked) {
                              this.setState({ appStatus: 0});
                            } else {
                              this.setState({ appStatus: 1});
                            }
                          }}
                        />
                      }
                      label="Active"
                    />
                  </FormGroup>
                </Grid>

                <Grid item xs={12}>
                  { !this.showSpinner() && this.state.appName &&
                  <Button variant="contained" disabled={this.disableAppSave()} style={AppBindStyles.bottomButton} onClick={() => {this._createApp()}}>
                    Save
                  </Button>}
                  { !this.showSpinner() && !this.state.appName &&
                  <Button variant="contained" disabled style={AppBindStyles.bottomButton}>
                    Save
                  </Button>}
                  {this.showSpinner() &&
                  <Button color="primary" variant="contained" >
                    <SavingSpinner/>
                  </Button>}
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        </Grid>
      );
    }
    else
    {
      return (
        <Redirect to='/home' />
      );
    }
  }
}

AppCreate.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styleSheet)(AppCreate);
